import { render, staticRenderFns } from "./BlockLoader.vue?vue&type=template&id=e22a5fcc&scoped=true&"
import script from "./BlockLoader.vue?vue&type=script&lang=js&"
export * from "./BlockLoader.vue?vue&type=script&lang=js&"
import style0 from "./BlockLoader.vue?vue&type=style&index=0&id=e22a5fcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22a5fcc",
  null
  
)

export default component.exports